import type { Messages } from './messages';

/**
 * Sentences that `lib/*.ts` modules say themselves — the upload queue's
 * failures, the password checklist and the shared المنشأة picker. Owned by lib.
 */
export const libMessages = {
  'password.rules': 'شروط كلمة المرور',
  'password.ruleLength': 'اثنا عشر حرفًا على الأقل — الطول وحده هو ما يهم.',
  'password.ruleVaried': 'ليست حرفًا واحدًا مكرّرًا ولا تسلسلًا متّصلًا.',
  'password.ruleObvious': 'لا تحتوي كلمة مرور شائعة أو تسلسلًا من لوحة المفاتيح.',
  'password.rulePersonal': 'لا تحتوي اسمك ولا بريدك ولا اسم منشأتك.',
  'password.hint': 'جملة قصيرة تتذكّرها أقوى من كلمة قصيرة معقّدة. لا نطلب رموزًا ولا أرقامًا.',
  'password.show': 'إظهار كلمة المرور',
  'password.hide': 'إخفاء كلمة المرور',

  'upload.noCrypto': 'المتصفح لا يسمح بحساب بصمة الملف على هذا العنوان. افتح اللوحة عبر https.',
  'upload.failed': 'تعذّر رفع الملف إلى المخزن. حاول مرة أخرى.',
  'upload.canceled': 'أُلغي الرفع.',
  'upload.noEtag': 'المخزن لم يُرجع إيصال الجزء، فتعذّر تجميع الملف.',

  'tenantPicker.search': 'ابحث عن منشأة',
  'tenantPicker.placeholder': 'الاسم أو المعرّف',
  'tenantPicker.caption': 'المنشآت المطابقة',
  'tenantPicker.tenant': 'المنشأة',
  'tenantPicker.status': 'الحالة',
  'tenantPicker.choose': 'اختيار {name}',
  'tenantPicker.chooseShort': 'اختيار',
  'tenantPicker.chooseHeader': 'اختيار المنشأة',
  'tenantPicker.none': 'لا منشأة بهذا الاسم',
  'tenantPicker.noneBody': 'جرّب جزءًا من الاسم أو المعرّف.',
  'tenantPicker.empty': 'لا منشآت بعد',
  'tenantPicker.emptyBody': 'أنشئ منشأة من صفحة المنشآت أولًا.',
} as const satisfies Messages<'password' | 'upload' | 'tenantPicker'>;
